import {
  TextInput,
  ChipInput,
  CustomSelect,
  TextArea,
  InputWithMediaInfo,
  GeneralPlayer,
  SelectedMediaCard,
} from "..";
import { RootState } from "../../store";
import {
  deleteSocialChannel,
  updateSocialChannel,
} from "@/store/app/app.actions";
import { getListMedia, getSearchedListMedia } from "@/store/media/media.action";
import { useFormik } from "formik";
import { InputWithMediaInfoRef } from "@/database";
import { useEffect, useRef, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import * as Yup from "yup";
import {
  generateBusinessOptions,
  generateTeamOptions,
  calculateTagCount,
} from "@/utils/mediautils/CommonFunctions";
import noImage from "../../assets/icons/svg/no-image.svg";
import { secondsToHms } from "../../utils";
import { generateBaseUrl, getThumbnailUrlUtil } from "@/utils/mediaUtils";
import { getYoutubePlaylist } from "@/store/app/app.actions";
import Modal from "../Modal/Modal";
import { GetMonetizationOptionsAPI } from "@/database";

import { DEFAULT_YOUTUBE_CATEGORIES } from "@/utils/constants/uiConstants";
import { formatEntityName } from "@/utils/utilFunctions/entityName";

const SocialSettings = ({
  item,
  updateSocialChannel,
  handleClose,
  getListMedia,
  getSearchedListMedia,
  preMediaList,
  postMediaList,
  mediaList,
  business,
  getYoutubePlaylist,
  youtubePlaylist,
  singleCurrentUser,
  bunchProductList,

  bunchBusinessProductMap,
}: Props) => {
  const [slateSelected, setSlateSelected] = useState<Record<string, any>>({});
  const [slateEdit, setSlateEdit] = useState<Record<string, boolean>>({});
  const [slateInputText, setSlateInputText] = useState<Record<string, string>>(
    {}
  );
  const slateRefs = useRef<Record<string, InputWithMediaInfoRef | null>>({});
  const [monetizationOptions, setMonetizationOptions] = useState<any[]>([]);
  const [isValidImage, setIsValidImage] = useState(true);

  const SLATE_ASPECTS: {
    key: "landscape" | "portrait" | "square";
    label: string;
  }[] = [
    { key: "landscape", label: "Landscape (16:9)" },
    { key: "portrait", label: "Portrait (9:16)" },
    { key: "square", label: "Square (1:1)" },
  ];

  const buildSlatePrePost = (
    val: { pre?: string; post?: string } | undefined
  ): { pre: string; post: string } => ({
    pre: val?.pre || "",
    post: val?.post || "",
  });

  const getTitleLimit = (platform: string) => {
    switch (platform) {
      case "facebook":
        return 95;
      case "youtube":
        return 100;
      case "instagram":
        return 2200;
      case "twitter":
        return 280;
      case "linkedin":
        return 1300;
      default:
        return 100;
    }
  };

  const getPrivacyOptions = (platform: string) => {
    switch (platform) {
      case "youtube":
        return [
          { label: "Public", value: "public" },
          { label: "Private", value: "private" },
          { label: "Unlisted", value: "unlisted" },
          // { label: 'Schedule', value: 'schedule' },
        ];
      case "facebook":
        return [
          { label: "Public", value: "public" },
          { label: "Private", value: "private" },
          // { label: 'Schedule', value: 'schedule' },
        ];
      case "linkedin":
        return [
          { label: "Public", value: "public" },
          { label: "Connections", value: "connections" },
        ];
      case "twitter":
      case "instagram":
        return [{ label: "Public", value: "public" }];
      default:
        return [
          { label: "Public", value: "public" },
          { label: "Private", value: "private" },
        ];
    }
  };

  const TITLE_LIMIT = getTitleLimit(item?.platform);
  const DESC_LIMIT = 5000;
  const TAGS_LIMIT = 500;
  const isYoutube = item?.platform === "youtube";
  const getTagsCharCount = (tags: string[]) =>
    calculateTagCount(tags || [], isYoutube).tagCount;

  const handleImageError = () => {
    setIsValidImage(false);
  };

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    initialValues: {
      title: item?.title || "",
      desc: item?.desc || "",
      tags: item?.tags || [],
      landscape_slate: buildSlatePrePost(item?.landscape_slate),
      portrait_slate: buildSlatePrePost(item?.portrait_slate),
      square_slate: buildSlatePrePost(item?.square_slate),
      monetization: item?.monetization || "",
      category: item?.category || "",
      playlist: item?.playlist || "",
      is_created_for_kids: item?.kids ? "yes" : "no",
      team: item.team || [],
      status: item.status || 0,
      right_management: item?.right_management || "yes",
      privacy: item?.privacy || "private",
      default_team: item?.default_team || "",
      is_sftp: item?.is_sftp ?? 1,
    },
    validationSchema: Yup.object({
      title: Yup.string().max(
        TITLE_LIMIT,
        `Title cannot exceed ${TITLE_LIMIT} characters`
      ),
      desc: Yup.string().max(
        DESC_LIMIT,
        `Description cannot exceed ${DESC_LIMIT} characters`
      ),
      tags: Yup.array().test(
        "tags-character-limit",
        `Tags cannot exceed ${TAGS_LIMIT} characters total`,
        function (value) {
          if (!value || value.length === 0) return true;
          return getTagsCharCount(value as string[]) <= TAGS_LIMIT;
        }
      ),
      team: Yup.array().of(Yup.string()).min(1, "Team is required"),
      default_team: Yup.string().required("Default Team is required"),
      status: Yup.number().required("Status is required"),
    }),

    onSubmit: (values) => {
      //
    },
  });

  useEffect(() => {
    if (item?.platform === "youtube" && item?.channel) {
      const fetchMonetizationOptions = async () => {
        try {
          const monetizationResponse = await GetMonetizationOptionsAPI(
            item.channel
          );
          if (monetizationResponse && monetizationResponse.status === 200) {
            setMonetizationOptions(monetizationResponse.data);
          }
        } catch (error) {
          console.error("Error fetching monetization options:", error);
        }
      };
      fetchMonetizationOptions();
    }
  }, [item?.platform, item?.channel]);

  useEffect(() => {
    if (item?.platform === "youtube" && item?.channel && getYoutubePlaylist) {
      getYoutubePlaylist(item.channel);
    }
  }, [item?.platform, item?.channel]);

  const getBasePermission = (permission: string): string => {
    return permission;
  };
  const handlePermissionChange = (values: string[], key: string) => {
    const newProducers = values.map((value) => value);
    formik.setFieldValue(key, newProducers);
  };

  function processPermissionForSelect(array: string[]) {
    const newarray = array.map((str) => {
      return getBasePermission(str);
    });
    return newarray;
  }
  const slateKey = (
    type: "pre" | "post",
    aspect: "landscape" | "portrait" | "square"
  ) => `${aspect}_slate_${type}`;

  const handleSlatePicked = (
    type: "pre" | "post",
    aspect: "landscape" | "portrait" | "square",
    newValue: any
  ) => {
    const k = slateKey(type, aspect);
    formik.setFieldValue(`${aspect}_slate.${type}`, newValue.label);
    setSlateSelected((prev) => ({ ...prev, [k]: newValue }));
    setSlateEdit((prev) => ({ ...prev, [k]: false }));
  };

  const handleSlateClose = (
    type: "pre" | "post",
    aspect: "landscape" | "portrait" | "square"
  ) => {
    const k = slateKey(type, aspect);
    formik.setFieldValue(`${aspect}_slate.${type}`, "");
    setSlateSelected((prev) => {
      const next = { ...prev };
      delete next[k];
      return next;
    });
    const orientationMap: Record<string, number> = {
      landscape: 1,
      portrait: 2,
      square: 3,
    };
    // getSearchedListMedia({
    //   stitle: "",
    //   key: type,
    //   asset_type: "slates",
    //   orientation: orientationMap[aspect],
    // });
  };

  const handleSlateEditClick = (
    type: "pre" | "post",
    aspect: "landscape" | "portrait" | "square"
  ) => {
    const k = slateKey(type, aspect);
    setTimeout(() => slateRefs.current[k]?.openMenu(), 0);
    setSlateEdit((prev) => ({ ...prev, [k]: true }));
  };

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [modalTitle, setModalTitle] = useState<string>("");
  const [modalContent, setModalContent] = useState<React.ReactNode | null>(
    null
  );

  const handleModalClose = () => {
    setIsModalOpen(false);
    setModalContent(null);
    setModalTitle("");
  };

  useEffect(() => {
    const ids = [
      item?.landscape_slate?.pre,
      item?.landscape_slate?.post,
      item?.portrait_slate?.pre,
      item?.portrait_slate?.post,
      item?.square_slate?.pre,
      item?.square_slate?.post,
    ].filter(Boolean) as string[];
    if (ids.length === 0) return;
    getListMedia({ id: ids, asset_type: "slates", key: "secondary" });
  }, []);

  const formikSlatesRef = useRef(formik.values);
  formikSlatesRef.current = formik.values;

  useEffect(() => {
    if (!Array.isArray(mediaList) || mediaList.length === 0) return;
    const { landscape_slate, portrait_slate, square_slate } =
      formikSlatesRef.current;
    const next: Record<string, any> = {};
    const assignSlate = (
      type: "pre" | "post",
      aspect: "landscape" | "portrait" | "square",
      id: string
    ) => {
      if (!id) return;
      const media = mediaList.find((m: any) => m.id === id);
      if (!media) return;
      next[slateKey(type, aspect)] = {
        label: media.id,
        value: media.title,
        image: media.images?.thumb
          ? getThumbnailUrlUtil({
              media,
              id: (media as any)?.is_vertical
                ? media?.images?.portrait
                : media?.images?.thumb,
              source: media?.source,
            })
          : "",
        duration: secondsToHms((media as any).meta?.duration || 0),
        thumb: !!generateBaseUrl(media as any),
      };
    };
    assignSlate("pre", "landscape", landscape_slate?.pre || "");
    assignSlate("post", "landscape", landscape_slate?.post || "");
    assignSlate("pre", "portrait", portrait_slate?.pre || "");
    assignSlate("post", "portrait", portrait_slate?.post || "");
    assignSlate("pre", "square", square_slate?.pre || "");
    assignSlate("post", "square", square_slate?.post || "");
    setSlateSelected(next);
  }, [mediaList]);

  return (
    <>
      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          onClose={handleModalClose}
          title={modalTitle}
          width="770px"
        >
          {modalContent}
        </Modal>
      )}
      <form
        className=""
        id="socialSettingsForm"
        onSubmit={async (e) => {
          e.preventDefault();
          Object.keys(formik.initialValues).forEach((field) => {
            formik.setFieldTouched(
              field as keyof typeof formik.initialValues,
              true
            );
          });
          const errors = await formik.validateForm();
          if (Object.keys(errors).length > 0) {
            return;
          }
          const kidsVal = formik.values.is_created_for_kids === "yes";
          updateSocialChannel({ ...formik.values, kids: kidsVal, id: item.id });
          handleClose();
        }}
      >
        <div className="d-flex">
          <div className="position-relative">
            <img
              src={
                isValidImage
                  ? item.platform === "facebook"
                    ? `https://graph.facebook.com/${item.id}/picture?type=small`
                    : item?.image ||
                      "https://yt3.ggpht.com/ytc/AIdro_kSGfJDEc-ehaGCvwnyuNBr8kfhML-Yew76Nj8hUUSrrke4-fZIU5cLYjQMy1xZcxRHzA=s88-c-k-c0x00ffffff-no-rj"
                  : noImage
              }
              alt=""
              height="50px"
              width="50px"
              className="rounded border"
              onError={handleImageError}
            />
            <i
              className={`bi bi-${item.platform} fw-bold fs-4 position-absolute px-1`}
              style={{
                bottom: -2,
                right: -2,
                backgroundColor: "white",
                color:
                  item.platform === "facebook"
                    ? "blue"
                    : item.platform === "linkedin"
                      ? "#0077B5"
                      : "red",
                borderRadius: "2px 0 0 0",
              }}
            ></i>
          </div>
          <div className="d-flex flex-column ms-2">
            <span className="fs-5 pb-2">{item.name}</span>
            <span className="fw-light fs-11">{item.platform} channel</span>
          </div>
        </div>
        <div
          className="mt-4"
          style={{
            fontSize: "15px",
            fontWeight: 600,
            color: "#212529",
            paddingBottom: "8px",
            borderBottom: "1px solid #e9ecef",
            marginBottom: "16px",
          }}
        >
          General
        </div>
        <div className="mb-3">
          <TextInput
            name="title"
            type="text"
            value={formik.values.title}
            onChange={(e) => {
              formik.handleChange(e);
              formik.setFieldTouched("title", true);
              formik.validateField("title");
            }}
            characterLimit={TITLE_LIMIT}
            showRequired={false}
            label={
              item?.platform === "twitter"
                ? "Postfix Tweet"
                : item?.platform === "instagram"
                  ? "Postfix Caption"
                  : "Postfix Title"
            }
            onBlur={formik.handleBlur}
            className={
              formik.values.title.length > TITLE_LIMIT ? "border-danger" : ""
            }
            touched={!!formik.touched.title}
            error={
              formik.values.title.length > TITLE_LIMIT
                ? `Title cannot exceed ${TITLE_LIMIT} characters`
                : (formik.errors.title as string)
            }
          />
        </div>
        {(item?.platform === "youtube" || item?.platform === "facebook") && (
          <div className="mb-3">
            <TextArea
              name="desc"
              value={formik.values.desc}
              onChange={(e) => {
                formik.handleChange(e);
                formik.setFieldTouched("desc", true);
                formik.validateField("desc");
              }}
              onBlur={formik.handleBlur}
              label="Postfix Description"
              showRequired={false}
              characterLimit={DESC_LIMIT}
              className={
                formik.values.desc.length > DESC_LIMIT ? "border-danger" : ""
              }
              touched={!!formik.touched.desc}
              error={
                formik.values.desc.length > DESC_LIMIT
                  ? `Description cannot exceed ${DESC_LIMIT} characters`
                  : (formik.errors.desc as string)
              }
            />
            {formik.touched.desc && formik.values.desc.length > DESC_LIMIT && (
              <div className="text-danger small mt-1">
                Description cannot exceed {DESC_LIMIT} characters
              </div>
            )}
          </div>
        )}
        <ChipInput
          label="Tags"
          value={formik.values.tags}
          placeholder="Type here to add Tags"
          className={
            formik.values.tags &&
            getTagsCharCount(formik.values.tags) > TAGS_LIMIT
              ? "border-danger"
              : ""
          }
          handleChipChange={(chip: string | string[], action: string) => {
            const currentTags = formik.values.tags || [];
            let newTags;
            if (action === "add") {
              const chipsToAdd = typeof chip === "string" ? [chip] : chip;
              newTags = [...new Set([...currentTags, ...chipsToAdd])];
            } else if (action === "remove") {
              const chipsToRemove = typeof chip === "string" ? [chip] : chip;
              newTags = currentTags.filter(
                (t: string) => !chipsToRemove.includes(t)
              );
            } else if (action === "clear") {
              newTags = [];
            } else {
              newTags = currentTags;
            }

            formik.setFieldValue("tags", newTags);
            formik.setFieldTouched("tags", true);
            setTimeout(() => {
              formik.validateField("tags");
            }, 0);
          }}
          touched={!!formik.touched.tags}
          error={
            formik.values.tags &&
            getTagsCharCount(formik.values.tags) > TAGS_LIMIT
              ? `Tags cannot exceed ${TAGS_LIMIT} characters`
              : (formik.errors.tags as string)
          }
          isYoutube={isYoutube}
        />
        {/* {formik.touched.tags &&
          formik.values.tags &&
          formik.values.tags.length > 0 && (
            <div
              className={`small mt-1 ${
                formik.values.tags.join(" ").length > TAGS_LIMIT
                  ? "text-danger"
                  : "text-muted"
              }`}
            >
              {formik.values.tags.join(" ").length}/{TAGS_LIMIT} characters
            </div>
          )} */}
        {/* {formik.touched.tags &&
          formik.values.tags &&
          formik.values.tags.join(" ").length > TAGS_LIMIT && (
            <div className="text-danger small mt-1">
              Tags cannot exceed {TAGS_LIMIT} characters total
            </div>
          )} */}
        <div className="row gy-3 mt-2">
          {item?.platform !== "youtube" && (
            <CustomSelect
              // value={formik.values.visibility}
              value={processPermissionForSelect(formik.values.team)}
              // value={prevVideoCredit}
              handleChange={(newValue: any) => {
                handlePermissionChange(
                  newValue.map((option: any) => option.value),
                  "team"
                );
              }}
              className="col-6"
              label="Visibility"
              multiSelect={true}
              placeholder="My Team"
              checkBox={true}
              showRequired={true}
              // options={generateTeamOptions(bunchBusinessProductMap, business)}
              options={bunchProductList?.map((item: any) => ({
                label: formatEntityName(item),
                value: item?.id,
              }))}
              hideArrow={true}
              error={formik.errors.team}
              touched={!!formik.touched.team}
              updatedOptions={bunchProductList?.map((item: any) => ({
                label: formatEntityName(item),
                value: item?.id,
              }))}
              // handleChange={(newValue: any) => formik.setFieldValue('visibility', newValue.value)}
            />
          )}

          <CustomSelect
            value={formik.values.default_team}
            className="col-6"
            label="Default Team"
            options={bunchProductList?.map((item: any) => ({
              label: formatEntityName(item),
              value: item?.id,
            }))}
            handleChange={(newValue: any) =>
              formik.setFieldValue("default_team", newValue.value)
            }
            showRequired={true}
            placeholder="Select Default team"
            error={formik.errors.default_team}
            updatedOptions={bunchProductList?.map((item: any) => ({
              label: formatEntityName(item),
              value: item?.id,
            }))}
            touched={!!formik.touched.default_team}
          />
          <CustomSelect
            value={formik.values.status}
            className="col-6"
            label="Status"
            showRequired={true}
            options={[
              { label: "Active", value: 1 },
              { label: "Inactive", value: 0 },
            ]}
            handleChange={(newValue: any) =>
              formik.setFieldValue("status", newValue.value)
            }
            error={formik.errors.status}
            touched={!!formik.touched.status}
          />
          {item?.platform === "youtube" && (
            <CustomSelect
              // value={formik.values.visibility}
              value={processPermissionForSelect(formik.values.team)}
              // value={prevVideoCredit}
              handleChange={(newValue: any) => {
                handlePermissionChange(
                  newValue.map((option: any) => option.value),
                  "team"
                );
              }}
              className="col-6"
              label="Visibility"
              multiSelect={true}
              placeholder="My Team"
              checkBox={true}
              showRequired={true}
              // options={generateTeamOptions(bunchBusinessProductMap, business)}
              options={bunchProductList?.map((item: any) => ({
                label: formatEntityName(item),
                value: item?.id,
              }))}
              updatedOptions={bunchProductList?.map((item: any) => ({
                label: formatEntityName(item),
                value: item?.id,
              }))}
              hideArrow={true}
              error={formik.errors.team}
              touched={!!formik.touched.team}
              // handleChange={(newValue: any) => formik.setFieldValue('visibility', newValue.value)}
            />
          )}
          {item?.platform === "youtube" && (
            <div className="col-6 d-flex  align-items-center">
              <label htmlFor="is_sftp">Enable SFTP</label>
              <div className="form-check form-switch mb-0 d-flex align-items-center">
                <input
                  className="form-check-input m-0"
                  type="checkbox"
                  role="switch"
                  id="is_sftp"
                  name="is_sftp"
                  checked={formik.values.is_sftp === 1}
                  onChange={(e) =>
                    formik.setFieldValue("is_sftp", e.target.checked ? 1 : 0)
                  }
                />
              </div>
            </div>
          )}
        </div>
        <div className="row mt-4 gy-3">
          <div
            className="col-12"
            style={{
              fontSize: "15px",
              fontWeight: 600,
              color: "#212529",
              paddingBottom: "8px",
              borderBottom: "1px solid #e9ecef",
              marginBottom: "8px",
            }}
          >
            Slates
          </div>
          <div className="col-12">
            <div
              className="d-flex align-items-center"
              style={{ gap: "12px", marginBottom: "8px" }}
            >
              <div style={{ flex: "0 0 130px" }} />
              <div
                style={{
                  flex: 1,
                  fontSize: "11px",
                  fontWeight: 600,
                  color: "#868e96",
                  letterSpacing: "0.04em",
                }}
              >
                OPENING SLATE
              </div>
              <div
                style={{
                  flex: 1,
                  fontSize: "11px",
                  fontWeight: 600,
                  color: "#868e96",
                  letterSpacing: "0.04em",
                }}
              >
                CLOSING SLATE
              </div>
            </div>
            {SLATE_ASPECTS.map(({ key: aspect, label }) => {
              const renderCell = (type: "pre" | "post") => {
                const k = slateKey(type, aspect);
                const selected = slateSelected[k];
                const editing = slateEdit[k];
                const slateField = `${aspect}_slate` as
                  | "landscape_slate"
                  | "portrait_slate"
                  | "square_slate";
                const value = formik.values[slateField]?.[type] || "";
                const orientationMap: Record<string, number> = {
                  landscape: 1,
                  portrait: 2,
                  square: 3,
                };
                const aspectOrientation = orientationMap[aspect];
                const rawOptions =
                  type === "pre" ? preMediaList : postMediaList;
                const options = Array.isArray(rawOptions)
                  ? rawOptions.filter(
                      (m: any) => m.orientation === aspectOrientation
                    )
                  : rawOptions;
                if (selected && !editing) {
                  return (
                    <SelectedMediaCard
                      media={selected}
                      type={type}
                      onClose={() => handleSlateClose(type, aspect)}
                      onEdit={() => handleSlateEditClick(type, aspect)}
                      showEditButton={true}
                      showDeleteButton={true}
                      showPreviewButton={true}
                      cardStyle={{ width: "60px", minWidth: "60px" }}
                      style={{ width: "100%" }}
                      maxLength={18}
                    />
                  );
                }
                return (
                  <InputWithMediaInfo
                    ref={(el: any) => {
                      slateRefs.current[k] = el;
                    }}
                    label=""
                    value={value}
                    handleChange={(newValue: any) =>
                      handleSlatePicked(type, aspect, newValue)
                    }
                    options={options}
                    onInputChangeCallback={(params: any) => {
                      const orientationMap: Record<string, number> = {
                        landscape: 1,
                        portrait: 2,
                        square: 3,
                      };
                      setSlateInputText((prev) => ({
                        ...prev,
                        [k]: params.keyword,
                      }));
                      getSearchedListMedia({
                        stitle: params.keyword,
                        asset_type: "slates",
                        key: type,
                        orientation: orientationMap[aspect],
                      });
                    }}
                    handleBlur={() =>
                      setSlateEdit((prev) => ({ ...prev, [k]: false }))
                    }
                    hideArrow={true}
                    right="11px"
                    initialStructuredData={selected}
                    initialInputText={
                      editing && selected
                        ? String(selected.value ?? "")
                        : (slateInputText[k] ?? undefined)
                    }
                    loader={true}
                    loaderRight="11px"
                  />
                );
              };
              return (
                <div
                  key={aspect}
                  className="d-flex align-items-center"
                  style={{ gap: "12px", marginBottom: "12px" }}
                >
                  <div
                    style={{
                      flex: "0 0 130px",
                      fontSize: "13px",
                      color: "#495057",
                    }}
                  >
                    {label}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    {renderCell("pre")}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    {renderCell("post")}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        {item?.platform === "youtube" && (
          <div className="row mt-4 gy-3">
            <div
              className="col-12"
              style={{
                fontSize: "15px",
                fontWeight: 600,
                color: "#212529",
                paddingBottom: "8px",
                borderBottom: "1px solid #e9ecef",
                marginBottom: "8px",
              }}
            >
              Channel settings
            </div>
            <CustomSelect
              value={formik.values.category}
              className="col-6"
              label="Category"
              placeholder="Select"
              options={Object.entries(DEFAULT_YOUTUBE_CATEGORIES).map(
                ([key, value]: any) => ({
                  label: value,
                  value: key,
                })
              )}
              handleChange={(newValue: any) =>
                formik.setFieldValue("category", newValue.value)
              }
              showRequired={false}
            />

            <CustomSelect
              value={formik.values.monetization}
              className="col-6"
              label="Monetize Video"
              placeholder="Select"
              options={monetizationOptions.map((option) => ({
                label: option.title,
                value: option.id,
              }))}
              handleChange={(newValue: any) =>
                formik.setFieldValue("monetization", newValue.value)
              }
              showRequired={false}
            />
            <CustomSelect
              value={
                formik.values.playlist
                  ? formik.values.playlist.split(",").filter(Boolean)
                  : []
              }
              className="col-6"
              label="Add to Playlist"
              placeholder="Select"
              options={
                youtubePlaylist?.map((playlist: any) => ({
                  label: playlist.title,
                  value: playlist.id,
                })) || []
              }
              handleChange={(newValue: any) => {
                const selectedValues = newValue
                  .map((v: any) => v.value)
                  .join(",");
                formik.setFieldValue("playlist", selectedValues || "");
              }}
              multiSelect={true}
              showRequired={false}
            />
            <CustomSelect
              value={formik.values.is_created_for_kids}
              className="col-6"
              label="Created for Kids"
              options={[
                { label: "Yes", value: "yes" },
                { label: "No", value: "no" },
              ]}
              handleChange={(newValue: any) => {
                formik.setFieldValue("is_created_for_kids", newValue.value);
              }}
              showRequired={false}
            />
            <CustomSelect
              value={formik.values.right_management ?? "yes"}
              label="RIGHTS MANAGEMENTS"
              className="col-6"
              options={[
                { label: "Yes", value: "yes" },
                { label: "No", value: "no" },
              ]}
              handleChange={(newValue: any) => {
                formik.setFieldValue("right_management", newValue.value);
              }}
              showRequired={false}
            />
            <CustomSelect
              value={formik.values.privacy ?? "private"}
              label="PRIVACY"
              className="col-6"
              options={getPrivacyOptions(item?.platform)}
              handleChange={(newValue: any) => {
                formik.setFieldValue("privacy", newValue.value);
              }}
              showRequired={false}
            />
          </div>
        )}
      </form>
    </>
  );
};

const mapState = (state: RootState) => ({
  currentSocial: state.app.userSocialChannels.currentSocial,
  mediaList: state.media.secondaryMediaList.list,
  preMediaList: state.media.preMediaList.list,
  postMediaList: state.media.postMediaList.list,
  business: state.users.singleCurrentUser?.business,
  youtubePlaylist: state.app.youtubePlaylist.data,
  singleCurrentUser: state.users.singleCurrentUser,
  bunchProductList: state.constants.bunchProductList.list,
  bunchBusinessProductMap: state.constants.bunchBusinessProductMap,
});

const mapDispatch = {
  updateSocialChannel,
  deleteSocialChannel,
  getListMedia,
  getSearchedListMedia,
  getYoutubePlaylist,
};

const connector = connect(mapState, mapDispatch);

interface PropsItem {
  item: any;
  handleClose?: any;
}

type Props = ConnectedProps<typeof connector> & PropsItem;

export default connector(SocialSettings);
